
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(465|787)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
